var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7084 10.2915L10.2918 15.7082M10.2917 10.2915L15.7084 15.7082",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 12.9998C23.8334 18.1067 23.8334 20.6602 22.2469 22.2466C20.6604 23.8332 18.1069 23.8332 13.0001 23.8332C7.89319 23.8332 5.33976 23.8332 3.75326 22.2466C2.16675 20.6602 2.16675 18.1067 2.16675 12.9998C2.16675 7.89295 2.16675 5.33951 3.75326 3.75301C5.33976 2.1665 7.89319 2.1665 13.0001 2.1665C18.1069 2.1665 20.6604 2.1665 22.2469 3.75301C23.3018 4.8079 23.6553 6.29027 23.7737 8.6665",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTop);
export default __webpack_public_path__ + "static/media/close-top.5b21552eed22f0b845342d58e55cbbc1.svg";
export { ForwardRef as ReactComponent };